module.exports = require("eslint-webpack-plugin");